export default __webpack_public_path__ + "static/media/C4.ff58cfab.gif";